const PERCENT = 100;

/**
 * Whether a row falls below the long-tail threshold — real spend, but not
 * spend anyone is looking for.
 *
 * The threshold is `tokenUsageLongTailPercent` from the ops settings rather
 * than a constant here, so the chip's label and the rows it folds away cannot
 * drift apart: both read the same number.
 *
 * A zero window total means every share is undefined rather than tiny, so
 * nothing counts as long tail — otherwise an empty window would "hide" every
 * row it contains and read as a filtered view of nothing.
 */
export function isLongTail(
  rowTokens: number,
  totalTokens: number,
  thresholdPercent: number,
): boolean {
  if (totalTokens <= 0) return false;
  return (rowTokens / totalTokens) * PERCENT < thresholdPercent;
}

/** Case-insensitive substring match. An empty query matches everything. */
export function matchesQuery(haystack: string, query: string): boolean {
  const needle = query.trim().toLowerCase();
  if (needle === "") return true;
  return haystack.toLowerCase().includes(needle);
}
